import { render } from "./AddPackage.vue?vue&type=template&id=187336f8&scoped=true"
import script from "./AddPackage.vue?vue&type=script&lang=js"
export * from "./AddPackage.vue?vue&type=script&lang=js"

import "./AddPackage.vue?vue&type=style&index=0&id=187336f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187336f8"]])

export default __exports__